export type RouteContext =
  | 'app'
  | 'sub'
  | 'subsub'
  | 'subsubsub'
  | 'subsubsubsub'
  | 'subsubsubsubsub'
  | 'subsubsubsubsubsub'
  | 'subsubsubsubsubsubsub'
  | 'subsubsubsubsubsubsubsub'
  | 'add-item'
  | 'add-item-subsub'
  | 'add-item-subsubsub'
  | 'add-item-subsubsubsub'
  | 'add-item-subsubsubsubsub'
  | 'add-item-subsubsubsubsubsub'
  | 'add-item-subsubsubsubsubsubsub'
  | 'add-item-subsubsubsubsubsubsubsub';

export const ROUTE_CONTEXTS: RouteContext[] = [
  'app',
  'sub',
  'subsub',
  'subsubsub',
  'subsubsubsub',
  'subsubsubsubsub',
  'subsubsubsubsubsub',
  'subsubsubsubsubsubsub',
  'subsubsubsubsubsubsubsub',
  'add-item',
  'add-item-subsub',
  'add-item-subsubsub',
  'add-item-subsubsubsub',
  'add-item-subsubsubsubsub',
  'add-item-subsubsubsubsubsub',
  'add-item-subsubsubsubsubsubsub',
  'add-item-subsubsubsubsubsubsubsub',
];

/** @deprecated Use bootstrap endpoint; kept for fallback */
export interface RouteLoaderConfig {
  endpoint: string;
  context: RouteContext;
}

const ENDPOINT_OVERRIDES: Partial<Record<RouteContext, string>> = {
  sub: 'category-sub',
};

export const ROUTE_LOADERS: RouteLoaderConfig[] = ROUTE_CONTEXTS.map(context => ({
  endpoint: ENDPOINT_OVERRIDES[context] ?? context,
  context,
}));
